export const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]).{8,}$/;

export const PHONE_NUMBER_REGEX = /^(\+\d{11})?$/;

export const ZIP_CODE_REGEX = /^(\d{5})?$/;

export const maxLimit = ({ max }) => `Should not exceed ${max} characters`;
